import './req.less';
import './layout.less';
import './detail.less';
import './promptBox.less';
import './icon.css';
import './status.less';
import './../components/smartGuessMap/style/index.less'
import './conflict-field.less';


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/style/main.js